import React from 'react';

const Modal = ({ open, title, onClose, children }: { open: boolean; title: string; onClose: () => void; children: React.ReactNode }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={onClose}>
      {/* No Escape-to-close here on purpose: the same Modal wraps the subscription settings
          form, and a stray Escape would discard a half-typed pricing change. */}
      <div role="dialog" aria-modal="true" aria-label={title} className="bg-white rounded-lg shadow-lg w-full max-w-md p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4"><h2 className="font-semibold">{title}</h2><button onClick={onClose} aria-label="Close" className="text-gray-400">✕</button></div>
        {children}
      </div>
    </div>
  );
};
export default Modal;
